module.exports = __webpack_public_path__ + "static/media/right-anchor.c5b8768c.svg";